/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostMemoryCommentImagesSignedurl200ResponseInner
 */
export interface PostMemoryCommentImagesSignedurl200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof PostMemoryCommentImagesSignedurl200ResponseInner
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryCommentImagesSignedurl200ResponseInner
     */
    filePath: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryCommentImagesSignedurl200ResponseInner
     */
    signedUrl: string;
    /**
     * 
     * @type {object}
     * @memberof PostMemoryCommentImagesSignedurl200ResponseInner
     */
    fields: object;
}

/**
 * Check if a given object implements the PostMemoryCommentImagesSignedurl200ResponseInner interface.
 */
export function instanceOfPostMemoryCommentImagesSignedurl200ResponseInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "filePath" in value;
    isInstance = isInstance && "signedUrl" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function PostMemoryCommentImagesSignedurl200ResponseInnerFromJSON(json: any): PostMemoryCommentImagesSignedurl200ResponseInner {
    return PostMemoryCommentImagesSignedurl200ResponseInnerFromJSONTyped(json, false);
}

export function PostMemoryCommentImagesSignedurl200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMemoryCommentImagesSignedurl200ResponseInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'filePath': json['filePath'],
        'signedUrl': json['signedUrl'],
        'fields': json['fields'],
    };
}

export function PostMemoryCommentImagesSignedurl200ResponseInnerToJSON(value?: PostMemoryCommentImagesSignedurl200ResponseInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'filePath': value.filePath,
        'signedUrl': value.signedUrl,
        'fields': value.fields,
    };
}

